module.exports = __webpack_public_path__ + "img/linkedin_white.9b3e4cd0.svg";